module.exports = __webpack_public_path__ + "img/downward02.603aa479.png";